import React from "react";
import styles from "./card-skeleton.module.scss";
import SkeletonC from "../../stories/common/skeleton";

const PropertyListCardSkeleton = () => {
  return (
    <div className={styles.propertyList}>
      <div className={styles.imgBox}>
        <SkeletonC width="100%" height="200px" />
      </div>
      <div className={styles.propertyInfo}>
        <SkeletonC width="100%" height="1.25rem" className="mb-1" />
        <SkeletonC width="100%" height="1.25rem" />

        <div className={styles.priceWrap}>
          <SkeletonC width="70%" height="2.5rem" className={styles.amount} />

          <SkeletonC shape="circle" size="2rem" />
        </div>
      </div>
    </div>
  );
};

export default PropertyListCardSkeleton;
